import React from 'react';
import { Input } from 'antd';
import _ from 'lodash';

const PasswordInputWithEyes = React.forwardRef((props, ref) => {
    return <div style={{ ...props.style, position: 'relative' }}>
        <Input.Password ref={ref} {..._.omit(props, "propsGenerator", "listField")} style={{ ...props.style, width: '100%' }} onChange={(e) => {
            props.onChange && props.onChange(e);
        }} />
    </div>
});

export default PasswordInputWithEyes;